import {client as http} from "@/http_client";

export default {
    state: {
        categories: null,
        selectedCategories: [],
        loadingCategories: false
    },
    getters: {
        categories: state => state.categories,
        selectedCategories: state => state.selectedCategories,
        loadingCategories: state => state.loadingCategories,
        // Flatten categories for filtering
        flatCategories: state => {
            if (!state.categories) return [];
            const flat = [];
            for (const cat of state.categories) {
                flat.push(cat);
                if (cat.children && cat.children.length > 0) {
                    for (const child of cat.children) {
                        flat.push(child);
                    }
                }
            }
            return flat;
        },
        // Get selected category IDs for API filtering
        selectedCategoryIds: state => state.selectedCategories.map(c => c.id)
    },
    mutations: {
        setCategories(state, categories) {
            state.categories = categories;
        },
        setSelectedCategories(state, categories) {
            state.selectedCategories = categories;
        },
        setLoadingCategories(state, loading) {
            state.loadingCategories = loading;
        },
        toggleCategory(state, category) {
            const index = state.selectedCategories.findIndex(c => c.id === category.id);
            if (index === -1) {
                state.selectedCategories.push(category);
            } else {
                state.selectedCategories.splice(index, 1);
            }
        },
        clearSelectedCategories(state) {
            state.selectedCategories = [];
        }
    },
    actions: {
        getCategories({state, commit}, certificationId) {
            return new Promise((resolve, reject) => {
                if (!certificationId) {
                    resolve([]);
                    return;
                }

                commit('setLoadingCategories', true);
                http.get('app/course-categories/', {
                    params: { certificationId },
                    force: true
                }).then(response => {
                    commit('setCategories', response.data);
                    commit('setLoadingCategories', false);
                    resolve(response.data);
                }).catch(err => {
                    console.log('Error loading categories:', err);
                    commit('setLoadingCategories', false);
                    reject(err);
                });
            });
        },
        toggleCategorySelection({commit}, category) {
            commit('toggleCategory', category);
        },
        clearCategorySelection({commit}) {
            commit('clearSelectedCategories');
        }
    }
};
